export default "__VITE_ASSET__BuWVA_Tp__"